import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { MatIconButton, MatFabButton, MatMiniFabButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { TranslateLangPipe } from '../../../../projects/shared-lib/src/lib/pipe/translate-lang.pipe';

@Component({
    selector: 'tw-template-header-dialog',
    templateUrl: './template-header-dialog.component.html',
    styleUrl: './template-header-dialog.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MatIconButton, MatIcon, TranslateLangPipe, MatFabButton, MatMiniFabButton],
})
export class TemplateHeaderDialogComponent {
    readonly titleEn = input<string>('');
    readonly titleFr = input<string>('');
    readonly disabled = input<boolean>(false);
    readonly closeClick = output<void>();
}
